import React, { useEffect, useState } from "react";

import { Col, Input, notification, Row, Select, Spin } from "antd";
import { Table } from "antd";

import { DatePicker, Space } from "antd";
import dayjs from "dayjs";

import moment from "moment";
import { useOutletContext } from "react-router-dom";
import axios from "axios";
import { GetSingleEmployeeData } from "../../../Services/CommonApis";

const CustomFooter = () => {
  // Custom footer content to render below the table
  return (
    <div style={{ textAlign: "right" }}>
      <span>Total: add items</span>
    </div>
  );
};

const keys = ["name", "dob", "age", "gender", "blood_group"];

const data = [
  {
    relation: "Self",
    no: 1,
    label: "self",
  },
  {
    relation: "Mother",
    no: 2,
    label: "mother",
  },
  {
    relation: "Father",
    no: 3,
    label: "father",
  },
  {
    relation: "Spouse",
    no: 4,
    label: "spouse",
  },
  {
    relation: "Child 1",
    no: 5,
    label: "child1",
  },
  {
    relation: "Child 2",
    no: 6,
    label: "child2",
  },
  // {
  //   relation: "Child 3",
  //   label: "child3",
  //   no: 7,
  // },
  // {
  //   relation: "Child 4",
  //   no: 8,
  //   label: "child4",
  // },
];

function validate(data) {
  for (const [key, value] of Object.entries(data)) {
    if (key === "self") {
      for (const k of keys) {
        if (!value[k]) {
          throw new Error(
            `${
              (k === "dob" && "DOB") ||
              (k === "blood_group" && "Blood Group") ||
              capitalizeFirstLetter(k)
            } is required`
          );
        }
      }
    }
  }
}
function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export default function Employee() {
  const [tableData, setTableData] = useState(data);
  const [isLoading, setIsLoading] = useState(true);
  const [date, setDate] = useState(data);

  const { profileData } = useOutletContext();
  const [isDateValue, setIsDateValue] = useState(false);

  const [api, contextHolder] = notification.useNotification();

  const [output, setOutput] = useState(null);
  const GetSingleData = async () => {
    const { data } = await GetSingleEmployeeData(
      sessionStorage.getItem("userId")
    );
    console.log(data?.data?.mediclaim, "chekcign data");
    if (data.success) {
      setIsDateValue(true);
      let obj = { ...data?.data?.mediclaim };
      for (const item of Object.keys({ ...data?.data?.mediclaim })) {
        obj = {
          ...obj,
          [item]: {
            ...obj[item],
            dob: obj[item].dob ? obj[item].dob.split(" ")[0] : null,
          },
        };
      }
      console.log(obj);
      setOutput({ ...obj, mobile: data?.data?.mobile });
      setIsLoading(false);
    }
  };
  useEffect(() => {
    GetSingleData();
  }, []);

  // console.log(Object.keys(output));

  const handleClickSubmit = async () => {
    if (Object.keys(output).length !== 0) {
      // try {
      //   validate(output);
      // } catch (e) {
      //   api.error({
      //     message: e.message,
      //     placement: "top",
      //   });
      //   return;
      // }

      const { data } = await axios.post(
        "/api/employee-connect/mediclaim/employee?=&=",
        output
      );
      if (data.succes) {
        console.log("success");
        api.success({
          message: data.message,
          placement: "top",
        });
        GetSingleData();
      } else {
        api.error({
          message: data.message,
          placement: "top",
        });
      }
    } else {
      api.error({
        message: "Name is required",
        placement: "top",
      });
    }

    // if (Object.keys(output).length !== 0) {
    //   console.log("not 0");
    //   if (output?.self) {
    //     if (!output?.self?.name) {
    //       api.error({
    //         message: "sdfsf",
    //         placement: "top",
    //       });
    //     }
    //     console.log("seldf", output?.self);
    //   }
    // } else {
    //
    // }
  };

  function handleChangeValue(value, field, relation) {
    setIsDateValue(false);
    setOutput((old) => ({
      ...old,
      [relation]: {
        ...old[relation],
        [field]: value,
      },
    }));
  }
  const dateFormat = "YYYY/MM/DD";

  const { dropDowns } = useOutletContext();
  const getDefaultDate = () => {
    // return moment("2015-06-06", "YYYY-MM-DD");
  };

  const columns = [
    {
      width: 77,
      title: "Sl. No.",
      dataIndex: "no",
      key: "no",
      render: (text) => <b className="p-4">{text}</b>,
    },
    {
      // fixed: "right",
      title: "Relationship",
      dataIndex: "relation",
      key: "relation",
      render: (text, total) => {
        return (
          <div className="custom-input responsive-row p-0 default-background-color">
            {" "}
            <b className="p-4">{text}</b>
          </div>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "name",
      render: (text, total) => (
        <div
          className="  custom-input responsive-row p-0 default-background-color"
          style={{
            borderRadius: "10px",
          }}
        >
          <Input
            value={output?.[total?.label]?.name}
            onChange={(e) => {
              handleChangeValue(e.target.value, "name", total.label);
            }}
          />
        </div>
      ),
    },
    {
      title: "D.O.B",
      dataIndex: "D.O.B",
      key: "dob",
      render: (text, total) => (
        <div className="custom-time-picker-table">
          {/* <DatePicker defaultValue={dayjs("2015-06-06", "YYYY-MM-DD")} /> */}

          {isLoading ? (
            ""
          ) : (
            <div>
              <DatePicker
                defaultValue={
                  output?.[total?.label]?.dob
                    ? dayjs(output?.[total?.label]?.dob)
                    : null
                }
                onChange={(value, date) =>
                  handleChangeValue(date, "dob", total.label)
                }
              />
              {/* {(output?.[total?.label]?.dob && (
                <DatePicker
                  defaultValue={moment(output?.[total?.label]?.dob)}
                  onChange={(value, date) =>
                    handleChangeValue(date, "dob", total.label)
                  }
                />
              )) || (
                <DatePicker
                  defaultValue=""
                  onChange={(value, date) =>
                    handleChangeValue(date, "dob", total.label)
                  }
                />
              )} */}
            </div>
          )}
        </div>
      ),
    },
    // {
    //   title: "Age",
    //   dataIndex: "Age",
    //   key: "age",
    //   render: (text, total) => (
    //     <div
    //       className="  custom-input responsive-row p-0 default-background-color"
    //       style={{
    //         borderRadius: "10px",
    //       }}
    //     >
    //       <Input
    //         value={output?.[total?.label]?.age}
    //         type="number"
    //         onChange={(e) =>
    //           handleChangeValue(e.target.value, "age", total?.label)
    //         }
    //       />
    //     </div>
    //   ),
    // },
    {
      title: "Gender",
      dataIndex: "Gender",
      key: "Gender",
      render: (text, total) => (
        <div
          className="  custom-input responsive-row p-0 default-background-color"
          style={{
            borderRadius: "10px",
          }}
        >
          <Select
            allowClear
            value={output?.[total?.label]?.gender}
            options={dropDowns && dropDowns.GENDER}
            onChange={(val) => {
              handleChangeValue(val, "gender", total.label);
            }}
          />
        </div>
      ),
    },
    {
      title: "Blood Group",
      dataIndex: "Blood Group",
      key: "blood_group",

      render: (text, total) => (
        <div
          className="  custom-input responsive-row p-0 default-background-color"
          style={{
            borderRadius: "10px",
          }}
        >
          <Select
            value={output?.[total?.label]?.blood_group}
            allowClear
            options={dropDowns && dropDowns.BLOOD_GROUP}
            onChange={(val) =>
              handleChangeValue(val, "blood_group", total.label)
            }
          />
        </div>
      ),
    },
    // {
    //   fixed: "right",
    //   title: "Relationship",
    //   dataIndex: "relation",
    //   key: "relation",
    //   render: (text, total) => {
    //     return (
    //       <div className="custom-input responsive-row p-0 default-background-color">
    //         {" "}
    //         <b className="p-4">{text}</b>
    //       </div>
    //     );
    //   },
    // },
  ];

  const handleAddingChild = () => {
    const filterChild = tableData?.filter(
      (e) => e.relation.split(" ")?.[0] === "Child"
    );
    setTableData([
      ...tableData,
      {
        relation: `Child ${filterChild?.length + 1}`,
        no: tableData?.length + 1,
        label: `child${filterChild?.length + 1}`,
      },
    ]);
  };
  return (
    <>
      {contextHolder}

      <section className="bg-white p-3 shadow-sm border border-gray-200 w-full rounded-2xl flex justify-between mb-2">
        <h2 className="text-2xl font-semibold text-gray-800">Mediclaim</h2>
      </section>
      <Row
        className="space-between py-2 bg-primary-custom text-white   p-3 box-shadow justify-between responsive-row default-background-color mt-3"
        style={{ borderRadius: "10px" }}
      >
        <Col className="py-2 flex-1 no-display">
          <span style={{ fontSize: "20px" }}>
            Employee Code: &nbsp; {profileData?.employee_id}
          </span>
        </Col>
        <Col className="py-2 flex-1  no-display">
          <span style={{ fontSize: "20px" }}>
            Employee Name: &nbsp; {profileData?.name?.full_name}
          </span>
        </Col>
      </Row>
      <div>
        <br />
        <div
          className=" box-shadow p-0 justify-between responsive-row default-background-color mt-0"
          style={{
            borderRadius: "10px",
          }}
        >
          <Table
            columns={columns}
            dataSource={tableData}
            pagination={false}
            scroll={{
              x: 900,
              // y: 400,
            }}
            // footer={() => (
            //   <button
            //     onClick={handleAddingChild}
            //     className="primary-btn small-btn float-right mb-4 opacity-100"
            //   >
            //     Add Child
            //   </button>
            // )}
          />
        </div>
        <Row
          className=" p-4 box-shadow responsive-row default-background-color mt-3 flex"
          style={{ borderRadius: "10px" }}
        >
          <span style={{ fontSize: "20px" }}>Mobile Number:</span>{" "}
          <Input
            className="w-auto ml-3"
            type="number"
            value={output?.mobile}
            onChange={(e) => setOutput({ ...output, mobile: e?.target?.value })}
          ></Input>
        </Row>
        <br />
        <br />
        <div className="">
          <button
            onClick={handleClickSubmit}
            className="primary-btn float-right opacity-100"
          >
            submit
          </button>
        </div>
        <br /> <br />
        <br /> <br />
      </div>
    </>
  );
}

// {
//   self:{
//     name:"skdflk"
//   }
// }
